module.exports = __webpack_public_path__ + "static/media/nigerdeltalogo.0b36d6c2.png";